export default "__VITE_ASSET__CKZXuns0__"